import { Button, Col, Form, Modal, Row, Select, Table, Tag } from 'antd';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { getBidderListSimple, getProjectListSimple } from '../../api/constlink';

const StyledDiv = styled.div``;

const { Option } = Select;

const columns = [
  {
    title: '회사명',
    dataIndex: ['vendor', 'application', 'general', 'name'],
  },
  {
    title: '대표명',
    dataIndex: ['vendor', 'application', 'general', 'representativeName'],
  },
  {
    title: '주력분야',
    dataIndex: ['vendor', 'application', 'general', 'type3'],
  },
  {
    title: '보유면허',
    dataIndex: ['vendor', 'application', 'general', 'type2'],
    width: '10%',
    render: (value: any, record: any, index: number) => {
      return (
        <>
          {value === null
            ? null
            : value.map((tag: any, index: any) => <Tag key={index}>{tag}</Tag>)}
        </>
      );
    },
  },
];

interface ImportBiddersModalProps {
  visible: boolean;
  enterpriseId: string;
  projectId: string;
  existingCollaborators: any[];
  onCreate: (userIdList: number[]) => void;
  onCancel: () => void;
}

function ImportBiddersModal({
  visible,
  enterpriseId,
  projectId,
  existingCollaborators,
  onCreate,
  onCancel,
}: ImportBiddersModalProps) {
  const [form] = Form.useForm();
  // const [users, setUsers] = useState<User[]>([]);
  const [projects, setProjects] = useState<any[]>([]);
  const [projectOptions, setProjectOptions] = useState<any>();
  const [bidPackageOptions, setBidPackageOptions] = useState<any>();
  const [collaborators, setCollaborators] = useState<any[]>([]);
  const [selectedRowKeysLocal, setSelectedRowKeysLocal] = useState<React.Key[]>(
    [],
  );

  const [bidders, setBidders] = useState<any[]>([]);

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      setBidders([...selectedRows]);
      setSelectedRowKeysLocal(selectedRowKeys);
    },
    selectedRowKeys: selectedRowKeysLocal,
    getCheckboxProps: (record: any) => ({
      disabled: record.disabled,
    }),
  };

  const _getBidderListSimple = async (formData: any) => {
    const data: any[] = await getBidderListSimple({
      enterpriseId,
      projectId,
      bidPackageId: formData.bidPackage,
    });

    for (const _bidder of data) {
      let disabled = false;
      for (const existingCollaborator of existingCollaborators) {
        if (existingCollaborator.vendor.id === _bidder.vendor.id)
          disabled = true;
      }
      _bidder.disabled = disabled;
    }
    setCollaborators(data);
  };

  useEffect(() => {
    (async () => {
      let _projects = await getProjectListSimple({ enterpriseId });
      _projects = _projects.filter((data: any) => data.id !== +projectId);
      setProjects(_projects);

      let children: any = [];
      for (const project of _projects) {
        children.push(
          <Option key={project.id} value={project.id}>
            {project.name}
          </Option>,
        );
      }
      setProjectOptions(children);
    })();
  }, [enterpriseId, projectId]);

  return (
    <StyledDiv>
      <Modal
        visible={visible}
        title="업체 불러오기"
        okText="확인"
        cancelText="취소"
        width={900}
        onCancel={onCancel}
        onOk={() => {
          const _enterpriseIdList: number[] = [];
          for (const bidder of bidders) {
            _enterpriseIdList.push(bidder.vendor.id);
          }
          onCreate(_enterpriseIdList);
        }}
      >
        <Form form={form} onFinish={_getBidderListSimple} initialValues={{}}>
          <Row justify="space-around">
            <Col span={11}>
              <Form.Item
                name="project"
                label="공사명"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  style={{ width: '100%' }}
                  onSelect={async (key: any, option: any) => {
                    const children = [];
                    for (const project of projects) {
                      if (project.id === option.value) {
                        for (const bidPackage of project.bidPackages) {
                          children.push(
                            <Option key={bidPackage.id} value={bidPackage.id}>
                              {bidPackage.name}(
                              {bidPackage.isBudgeting ? '견적' : '입찰'})
                            </Option>,
                          );
                        }
                        setBidPackageOptions(children);
                      }
                    }
                  }}
                >
                  {projectOptions}
                </Select>
              </Form.Item>
            </Col>
            <Col span={11}>
              <Form.Item
                noStyle
                shouldUpdate={(prevValues, currentValues) =>
                  prevValues.project !== currentValues.project
                }
              >
                {({ getFieldValue }) =>
                  getFieldValue('project') !== undefined ? (
                    <Form.Item
                      name="bidPackage"
                      label="외주/자재 견적"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Select
                        style={{ width: '100%' }}
                        disabled={form.getFieldValue('project') === undefined}
                        onSelect={async (key: any, option: any) => {
                          // if (form.getFieldValue('approvalType') === '1') {
                          //   console.log(option);
                          //   let children: any = [];
                          //   for (const bidder of projectSimpleData?.bidPackages.find(
                          //     (data: any) => data.id === +option.key,
                          //   ).bidders) {
                          //     children.push(
                          //       <Option key={bidder.id} value={bidder.id}>
                          //         {bidder.bidEnterprise.name} (입찰가:{' '}
                          //         {bidder?.recentAmount === null
                          //           ? '없음'
                          //           : `${priceToString(bidder?.recentAmount)}원`}
                          //         )
                          //       </Option>,
                          //     );
                          //   }
                          //   setBidderOptions(children);
                          // }
                        }}
                      >
                        {bidPackageOptions}
                      </Select>
                    </Form.Item>
                  ) : null
                }
              </Form.Item>
            </Col>
          </Row>
          <Row justify="end">
            <Col span={2}>
              <Form.Item>
                <Button type="primary" htmlType="submit">
                  검색
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Table
          rowKey="id"
          columns={columns}
          rowSelection={{ ...rowSelection, checkStrictly: false }}
          dataSource={collaborators}
        />
      </Modal>
    </StyledDiv>
  );
}

export default ImportBiddersModal;
